// Resolve {lat,lng} to a Persian address string via the existing /api/reverse
// endpoint (server-side Neshan -> OpenCage -> Nominatim fallback chain). Returns
// '' when the providers find nothing, so callers can keep the field editable
// rather than block the form. Throws only on a transport/HTTP failure.
export async function reverseGeocode(lat, lng) {
  const res = await fetch(`/api/reverse?lat=${lat}&lng=${lng}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return data.address || '';
}
